import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { AvatarForm, FormValues } from "./AvatarForm";
import { AvatarList } from "./AvatarList";

interface AvatarOption {
  id: number;
  url: string;
  alt: string;
}

const avatarOptions: AvatarOption[] = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7",
    alt: "Professional woman with laptop"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d",
    alt: "Person using MacBook Pro"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158",
    alt: "Woman with laptop"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e",
    alt: "Robot avatar"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1581092795360-fd1ca04f0952",
    alt: "Man in checkered shirt"
  }
];

export const AvatarGrid = () => {
  const [selectedAvatar, setSelectedAvatar] = useState<number | null>(null);
  const [customAvatars, setCustomAvatars] = useState<AvatarOption[]>([]);
  const { toast } = useToast();

  useEffect(() => {
    const savedCustomAvatars = localStorage.getItem('customAvatars');
    if (savedCustomAvatars) {
      setCustomAvatars(JSON.parse(savedCustomAvatars));
    }
  }, []);

  const handleAvatarSelect = (avatarId: number) => {
    setSelectedAvatar(avatarId === selectedAvatar ? null : avatarId);
  };

  const handleSaveSelection = () => {
    if (!selectedAvatar) {
      toast({
        title: "Nenhum avatar selecionado",
        description: "Por favor, selecione um avatar antes de continuar.",
        variant: "destructive",
      });
      return;
    }

    const allAvatars = [...avatarOptions, ...customAvatars];
    const selectedAvatarData = allAvatars.find(avatar => avatar.id === selectedAvatar);
    if (selectedAvatarData) {
      localStorage.setItem('selectedAvatar', JSON.stringify(selectedAvatarData));
      toast({
        title: "Avatar selecionado com sucesso!",
        description: "Seu novo avatar foi salvo.",
      });
    }
  };

  const handleDeleteAvatar = (avatarId: number) => {
    const updatedCustomAvatars = customAvatars.filter(avatar => avatar.id !== avatarId);
    setCustomAvatars(updatedCustomAvatars);
    localStorage.setItem('customAvatars', JSON.stringify(updatedCustomAvatars));
    
    if (selectedAvatar === avatarId) {
      setSelectedAvatar(null);
    }

    toast({
      title: "Avatar removido",
      description: "O avatar foi removido com sucesso.",
    });
  };

  const handleAddAvatar = (values: FormValues) => {
    const newAvatar: AvatarOption = {
      id: Date.now(),
      url: values.imageUrl,
      alt: "Custom avatar"
    };

    const updatedCustomAvatars = [...customAvatars, newAvatar];
    setCustomAvatars(updatedCustomAvatars);
    localStorage.setItem('customAvatars', JSON.stringify(updatedCustomAvatars));
    
    toast({
      title: "Avatar adicionado",
      description: "Novo avatar foi adicionado à lista e salvo.",
    });
  };

  const allAvatars = [...avatarOptions, ...customAvatars];

  return (
    <div className="space-y-6">
      <AvatarForm onSubmit={handleAddAvatar} />
      <AvatarList
        avatars={allAvatars}
        defaultAvatars={avatarOptions}
        selectedAvatar={selectedAvatar}
        onSelect={handleAvatarSelect}
        onDelete={handleDeleteAvatar}
      />
      <Button 
        onClick={handleSaveSelection}
        className="w-full md:w-auto"
      >
        Salvar Seleção
      </Button>
    </div>
  );
};